import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cfc0952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_wrap" }
const _hoisted_2 = {
  key: 0,
  class: "url_box"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "packet_cover" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "txt" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "扫一扫领红包", -1))
const _hoisted_8 = { class: "packet_cover_qrcode_warp" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "packet_list"
}
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "txt" }
const _hoisted_13 = { class: "packet_list_header" }
const _hoisted_14 = { class: "sub_title" }
const _hoisted_15 = { class: "packet_list_main" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "packet_list_item_desc" }
const _hoisted_18 = { class: "plid_txt mod_ellip" }
const _hoisted_19 = { class: "plid_time" }
const _hoisted_20 = { class: "packet_list_item_info" }
const _hoisted_21 = { class: "plid_txt" }
const _hoisted_22 = { class: "luck_txt" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "packet_list"
}
const _hoisted_25 = { class: "txt" }
const _hoisted_26 = { class: "packet_list_header" }
const _hoisted_27 = { class: "packet_list_main" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "packet_list_item_desc" }
const _hoisted_30 = { class: "plid_txt mod_ellip" }
const _hoisted_31 = { class: "plid_time" }
const _hoisted_32 = { class: "packet_list_item_info" }
const _hoisted_33 = {
  key: 2,
  class: "packet_empty"
}

import { reactive, watch, defineAsyncComponent, computed } from 'vue';
import { Button, message } from 'ant-design-vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import { useConsoleStore } from '@/pinia/console';
import GroupMsgItem from './GroupMsgItem.vue';
import GroupMsgItemChat from './GroupMsgItemChat.vue';
import { GroupChat, PrivateMsgObj } from '@/pinia/types/console';
import http from '@/api';
import { useDebounce } from '@/hooks/useDebounce';
import { RedEnvelopeContent } from '@/pinia/types/livechat';
import { addZero, dateFormat } from '@/utils/format';
import { RedPackLogo, Crown } from '@/assets';
import { useQRCode } from '@vueuse/integrations/useQRCode';

import EventBus from '@/components/EventBus';
import { emptyDataSec } from '@/assets';

interface Packet {
  id: string;
  command: string;
  type: number;
  typeName: string;
  contest_type: number;
  message: string;
}
/**
 * @description 标准红包
 *
 * @created_at 时间
 * @money 红包总金额
 * @num 红包总数量
 * @second 红包领完的耗时
 * @snatch_amount 领取金额
 * @snatch_num 领取数量
 */
interface StandPacket extends Packet {
  created_at: string;
  money: string;
  num: number;
  second: string;
  snatch_amount: number;
  snatch_num: number;
}
/**
 * @description 标准红包领取列表
 *
 * @created_at 领取时间
 * @luckiest 手气最佳标识
 * @snatch_amount 领取金额
 * @snatch_avatar_url 头像
 * @snatch_name 用户名
 */
interface StandSnatch {
  created_at: string;
  luckiest: number;
  snatch_amount: string;
  snatch_avatar_url: string;
  snatch_name: string;
}
/**
 * @description 竞答红包or礼物
 *
 * @prize_title 礼物标题
 * @prize_url 礼物url
 * @amount 红包总金额
 * @received_num 红包领取数量
 * @redpack_num 红包总数量
 * @remaining_num 红包剩余数量
 */
interface CompePacket extends Packet {
  prize_title: string;
  prize_url: string;
  amount: string;
  received_num: number;
  redpack_num: number;
  remaining_num: number;
}
/**
 * @description 竞答红包领取列表
 *
 * @id
 * @amount 金额
 * @avatar_url 头像
 * @created_at 时间
 * @prize_id 礼物ID
 * @user_id 用户ID
 * @user_name 用户名
 */
interface CompetSnatch {
  id: number;
  amount: string;
  avatar_url: string;
  created_at: string;
  prize_id: number;
  user_id: number;
  user_name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupMessage',
  setup(__props) {

const CustomModal = defineAsyncComponent(() => import('@/components/CustomModal.vue'));

const aButton = Button;
const consoleStore = useConsoleStore();

/**
 * @description 点赞
 */
const setLike = useDebounce(async (formData: GroupChat) => {
  try {
    const status = Number(!formData.like);
    let res: any = {};
    if (status === 1) {
      res = await http.liveChat.setChatLike({
        msg_id: formData.msg_id,
        studio_id: consoleStore.consoleInfo.id,
      });
    } else {
      res = await http.liveChat.setChatUnLike({
        msg_id: formData.msg_id,
        studio_id: consoleStore.consoleInfo.id,
      });
    }
    formData.like_num = status ? formData.like_num + 1 : formData.like_num - 1;
    formData.like = status;
    const index = consoleStore.groupMsg.list.findIndex((e) => e.msg_id === formData.msg_id);
    consoleStore.groupMsg.list[index] = formData;
    message.success(res.data.message);
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description 用户信息设置审核 功能一
 *  公共列表数据的评论为初始化第一条与socket的数据集合，其他为组件单独请求拼接的数据
 */
const setAudit = useDebounce(async <T extends GroupChat & { group_msg_id: string; staticData: boolean }>(formData: T) => {
  try {
    const status = formData.status === 2 ? 1 : Number(!formData.status);
    await http.liveChat.msgReview({
      group: formData.group_msg_id ? 2 : 1,
      monitor_id: consoleStore.authority.monitor_id,
      msg_id: formData.msg_id,
      status: status,
      studio_id: consoleStore.consoleInfo.id,
    });
    if (formData.staticData) {
      EventBus.emit('updateComment', {
        comment_msg_id: formData.msg_id,
        group_msg_id: formData.group_msg_id,
        status: status,
      });
      return;
    }
    if (formData.group_msg_id) {
      consoleStore.groupMsg.list.forEach((e) => {
        if (e.msg_id === formData.group_msg_id) {
          const index = e.comment.findIndex((o) => o.comment_msg_id.toString() == formData.msg_id);
          e.comment[index].comment_status = status;
        }
      });
    } else {
      const index = consoleStore.groupMsg.list.findIndex((e) => e.msg_id === formData.msg_id);
      consoleStore.groupMsg.list[index].status = status;
    }
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description 弹幕弹出
 */
const onSendBarrage = useDebounce(async (formData: GroupChat) => {
  try {
    const status = Number(!formData.status);
    const res = await http.liveChat.msgBarrage({
      group: 1,
      monitor_id: consoleStore.authority.monitor_id,
      msg_id: formData.msg_id,
      status: status,
      studio_id: consoleStore.consoleInfo.id,
    });
    message.success(res.data.message);
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description 互动聊天-（取消置顶）and 置顶
 */
const setMsgTop = useDebounce(async (formData: GroupChat) => {
  try {
    const topStatus = Number(!formData.top_status);
    const res = await http.liveChat.msgTop({
      group: 1,
      monitor_id: consoleStore.authority.monitor_id,
      msg_id: formData.msg_id,
      top_status: topStatus,
      studio_id: consoleStore.consoleInfo.id,
    });
    const index = consoleStore.groupMsg.list.findIndex((e) => e.msg_id === formData.msg_id);
    consoleStore.groupMsg.list[index].top_status = topStatus;
    if (topStatus) {
      consoleStore.groupMsg.list.splice(index, 1);
      consoleStore.groupMsg.list.unshift(formData);
      consoleStore.groupMsg.topCount += 1;
    } else {
      consoleStore.groupMsg.list.splice(index, 1);
      consoleStore.groupMsg.topCount -= 1;
      consoleStore.groupMsg.list.splice(consoleStore.groupMsg.topCount, 0, formData);
    }

    message.success(res.data.message);
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description 互动聊天消息与评论删除
 * @param GroupChat.group_msg_id 消息ID
 * @param GroupChat.staticData 是否为静态消息（非socket添加的数据）
 */
const onDelMsg = useDebounce(async <T extends GroupChat & { group_msg_id: string; staticData: boolean }>(formData: T) => {
  try {
    const res = await http.liveChat.msgDelete({
      group: formData.group_msg_id ? 2 : 1,
      monitor_id: consoleStore.authority.monitor_id,
      msg_id: formData.msg_id,
      status: 1,
      studio_id: consoleStore.consoleInfo.id,
    });
    if (formData.staticData) {
      EventBus.emit('delComment', {
        comment_msg_id: formData.msg_id,
        group_msg_id: formData.group_msg_id,
      });
      return;
    }
    if (formData.group_msg_id) {
      consoleStore.groupMsg.list.forEach((e) => {
        if (e.msg_id === formData.group_msg_id) {
          const newArr = e.comment.filter((o) => o.comment_msg_id.toString() !== formData.msg_id);
          e.comment = newArr;
        }
      });
    } else {
      const index = consoleStore.groupMsg.list.findIndex((e) => e.msg_id === formData.msg_id);
      consoleStore.groupMsg.list.splice(index, 1);
      if (formData.top_status === 1) {
        consoleStore.groupMsg.topCount -= 1;
      }
    }
    message.success(res.data.message);
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description   互动聊天-禁言
 * @param type 'uid' or 'to_uid'
 */

const setGroupMute = useDebounce(async (formData: GroupChat, type?: string) => {
  try {
    const res = await http.liveChat.groupMute({
      avatar: type === 'to_uid' ? formData.to_avatar : formData.avatar,
      nickname: type === 'to_uid' ? formData.to_nickname : formData.nickname,
      status: 1,
      monitor_id: consoleStore.authority.monitor_id,
      studio_id: consoleStore.consoleInfo.id,
      uid: type === 'to_uid' ? formData.to_uid : formData.uid,
    });
    message.success(res.data.message);
  } catch (err: any) {
    message.error(err.data.error);
  }
});
/**
 * @description 互动聊天-拉黑
 */
const setPullBlack = useDebounce(async (formData: GroupChat, type?: string) => {
  try {
    const res = await http.liveChat.pullBlack({
      avatar: type === 'to_uid' ? formData.to_avatar : formData.avatar,
      nickname: type === 'to_uid' ? formData.to_nickname : formData.nickname,
      status: 1,
      monitor_id: consoleStore.authority.monitor_id,
      studio_id: consoleStore.consoleInfo.id,
      uid: type === 'to_uid' ? formData.to_uid : formData.uid,
    });
    message.success(res.data.message);
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description 私聊用户功能
 */
const toChat = useDebounce((formData: GroupChat) => {
  consoleStore.chatType = 0;
  const data = new PrivateMsgObj(formData);
  consoleStore.currentDialog.user = data;
  consoleStore.toDialogMsg(consoleStore.consoleInfo.id, data.to_uid);
});

/**
 * @description 信息右键功能
 * 1 弹幕 2 置顶 4 禁言 5 拉黑 6 私聊 7 删除
 */
const setEditUser = (formData: { data: GroupChat & { group_msg_id: string; staticData: boolean }; key: number }) => {
  switch (formData.key) {
    case 1:
      onSendBarrage(formData.data);
      break;
    case 2:
      setMsgTop(formData.data);
      break;
    case 4:
      setGroupMute(formData.data);
      break;
    case 5:
      setPullBlack(formData.data);
      break;
    case 6:
      toChat(formData.data); //私聊
      break;
    case 7:
      onDelMsg(formData.data);
      break;
    default:
      setAudit(formData.data);
      break;
  }
};

/**
 * @description   公共私聊-禁言
 * @param type 'uid' or 'to_uid'
 */

const setPrivateMute = useDebounce(async (formData: GroupChat, type?: string) => {
  try {
    if (type === 'to_uid') {
      const data = {
        chat_list_id: formData.chat_list_id,
        status: formData.status === 2 ? 0 : 2,
        studio_id: consoleStore.consoleInfo.id,
      };
      formData.status === 2 ? (formData.status = 0) : (formData.status = 2);
      const res = await http.liveChat.privateMute(data);
      message.success(res.data.message);
    } else {
      const data = {
        chat_list_id: formData.chat_list_id,
        status: formData.to_status === 2 ? 0 : 2,
        studio_id: consoleStore.consoleInfo.id,
        uid: formData.uid,
      };
      formData.to_status === 2 ? (formData.to_status = 0) : (formData.to_status = 2);
      const res = await http.liveChat.privateMute(data);
      message.success(res.data.message);
    }
  } catch (err: any) {
    message.error(err.data.error);
  }
});

/**
 * @description 他人私聊信息功能操作
 */
const setEditPUser = (formData: { data: GroupChat; key: number; type: string }) => {
  switch (formData.key) {
    case 4:
      setPrivateMute(formData.data, formData.type);
      break;
    case 5:
      setPullBlack(formData.data, formData.type);
      break;
  }
};
/**
 * 评论
 */
const onCommentUser = (data: any) => {
  EventBus.emit('toComment', data);
};

/**
 * @description 红包信息对象
 *
 * @command 封面文案
 * @type 红包类型
 * @typeName 红包类型名称 - 自定义属性
 * @contest_type 红包内容类型 现金红包 1 or 礼物红包 2
 */
const packet = reactive<{
  visible: boolean;
  isShowList: boolean;
  data: Packet | StandPacket | CompePacket;
  list: StandSnatch[] | CompetSnatch[];
}>({
  visible: false,
  isShowList: false,
  data: {
    id: '',
    command: '',
    type: 1,
    typeName: '',
    contest_type: 1,
    message: '还未有人领取红包!',
  },
  list: [],
});
watch(
  () => packet.visible,
  (newVal) => {
    if (newVal === false) {
      packet.isShowList = false;
      packet.data = {
        id: '',
        command: '',
        type: 1,
        typeName: '',
        contest_type: 1,
        message: '还未有人领取红包!',
      };
      packet.list = [];
    }
  }
);
const openPacket = async (redPaketData: RedEnvelopeContent) => {
  packet.data.id = redPaketData.id;
  packet.data.type = redPaketData.type;
  packet.data.typeName = redPaketData.type_name;
  packet.data.command = redPaketData.command;
  packet.data.contest_type = redPaketData.contest_type ? Number(redPaketData?.contest_type) : 1;
  packet.visible = true;
};

const onViewList = async () => {
  try {
    if (packet.data.type === 4) {
      const res: any = await http.liveChat.getRedpackSnatchList({
        params: {
          envelope_id: packet.data.id,
          studio_id: consoleStore.consoleInfo.id,
          type: Number(packet.data.contest_type),
        },
      });
      const resData = res.data.data;
      const compData = packet.data as CompePacket;
      compData.amount = resData.amount;
      compData.prize_title = resData.prize_title;
      compData.prize_url = resData.prize_url;
      compData.received_num = resData.received_num;
      compData.redpack_num = resData.redpack_num;
      compData.remaining_num = resData.remaining_num;
      packet.list = resData.user_snatch_list;
    } else {
      const res = await http.liveChat.getRedpackInfo({
        params: {
          envelope_id: packet.data.id,
          studio_id: consoleStore.consoleInfo.id,
        },
      });
      const resData: any = res.data.data;
      const standData = packet.data as StandPacket;
      standData.created_at = dateFormat(new Date(resData.created_at));
      standData.money = resData.money;
      standData.num = resData.num;
      standData.second = '';
      const day = parseInt((resData.second / (24 * 60 * 60)).toString(), 10);
      const hour = parseInt(((resData.second / (60 * 60)) % 24).toString(), 10);
      const minute = parseInt(((resData.second / 60) % 60).toString(), 10);
      const second = parseInt((resData.second % 60).toString(), 10);
      standData.second += day ? `${addZero(day)} 天` : '';
      standData.second += hour ? `${addZero(hour)} 时` : '';
      standData.second += minute ? `${addZero(minute)} 分` : '';
      standData.second += second ? `${addZero(second)} 秒 ` : '';
      standData.snatch_amount = resData.snatch_amount;
      standData.snatch_num = resData.snatch_num;
      const resList = await http.liveChat.getRedpackRankConsole({
        params: {
          envelope_id: packet.data.id,
          studio_id: consoleStore.consoleInfo.id,
        },
      });
      standData.message = resList.data.message;
      packet.list = resList.data.data;
    }
    packet.isShowList = true;
  } catch (err: any) {
    console.error(err.data.error);
  }
};

const qrCodeUrl = computed(() => consoleStore.consoleInfo.qrCodeUrl);
const qrcode = useQRCode(qrCodeUrl, {
  margin: 3,
});

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(consoleStore).groupMsg.list.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_empty, {
            class: "empty_wrap",
            image: _unref(emptyDataSec),
            description: "页面暂无新消息~"
          }, null, 8, ["image"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(consoleStore).groupMsg.list, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.msg_id
      }, [
        (item.chat_list_id)
          ? (_openBlock(), _createBlock(GroupMsgItemChat, {
              key: 0,
              "source-data": item,
              self: _unref(consoleStore).authority.uid === item.uid,
              "onClick:setEditPUser": setEditPUser
            }, null, 8, ["source-data", "self"]))
          : (_openBlock(), _createBlock(GroupMsgItem, {
              key: 1,
              "source-data": item,
              self: _unref(consoleStore).authority.uid === item.uid,
              "onUpdate:setLike": ($event: any) => (_unref(setLike)(item)),
              "onClick:setEditUser": setEditUser,
              "onClick:openPacket": openPacket,
              "onClick:onCommentUser": onCommentUser
            }, null, 8, ["source-data", "self", "onUpdate:setLike"]))
      ]))
    }), 128)),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal-container" }, [
      _createVNode(_unref(CustomModal), {
        modelValue: packet.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((packet.visible) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["packet_wrap", { on: packet.isShowList }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["packet_wrap_circle_mark", { on: packet.isShowList }])
            }, null, 2),
            _createElementVNode("img", {
              src: _unref(RedPackLogo),
              alt: "",
              class: "packet_logo_mark"
            }, null, 8, _hoisted_3),
            _createVNode(_unref(CloseOutlined), {
              class: "packet_close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (packet.visible = false))
            }),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, "管理员的" + _toDisplayString(packet.data.typeName), 1),
              _createElementVNode("h2", _hoisted_6, _toDisplayString(packet.data.command), 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _unref(qrcode),
                  alt: "QR Code"
                }, null, 8, _hoisted_9)
              ]),
              _createVNode(_unref(aButton), {
                type: "link",
                class: "packet_cover_link",
                onClick: onViewList
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查看大家手气 >")
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, !packet.isShowList]
            ]),
            (packet.data.type !== 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("h2", _hoisted_11, "管理员的" + _toDisplayString(packet.data.typeName), 1),
                  _createElementVNode("h2", _hoisted_12, _toDisplayString(packet.data.command), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createTextVNode(_toDisplayString(`已领取 ${ (packet.data as StandPacket ).snatch_num }/${ (packet.data as StandPacket ).num } 个，共 ${ (packet.data as StandPacket ).snatch_amount }/${ (packet.data as StandPacket ).money } 元`) + " ", 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString((packet.data as StandPacket ).second ?`${(packet.data as StandPacket ).second}被抢完` : ''), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((packet.list as StandSnatch[] ), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.created_at,
                        class: "packet_list_item"
                      }, [
                        _createElementVNode("img", {
                          class: "packet_list_item_avatar",
                          src: item.snatch_avatar_url,
                          alt: ""
                        }, null, 8, _hoisted_16),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.snatch_name), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(item.created_at), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(`${item.snatch_amount} 元`), 1),
                          _withDirectives(_createElementVNode("div", _hoisted_22, [
                            _createElementVNode("img", {
                              src: _unref(Crown),
                              alt: ""
                            }, null, 8, _hoisted_23),
                            _createTextVNode(" 手气最佳 ")
                          ], 512), [
                            [_vShow, item.luckiest]
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("h2", _hoisted_25, _toDisplayString(packet.data.contest_type === 2 ? (packet.data as CompePacket).prize_title : `总金额：${(packet.data as CompePacket).amount} 元`), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(`已领取 ${ (packet.data as CompePacket ).received_num }/${ (packet.data as CompePacket ).redpack_num } 个，剩余
              ${(packet.data as CompePacket ).remaining_num}个`), 1),
                  _createElementVNode("ul", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((packet.list as CompetSnatch[] ), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "packet_list_item"
                      }, [
                        _createElementVNode("img", {
                          class: "packet_list_item_avatar",
                          src: item.avatar_url,
                          alt: ""
                        }, null, 8, _hoisted_28),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(item.user_name), 1),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(item.created_at), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(packet.data.contest_type === 2 ? (packet.data as CompePacket).prize_title : `${item.amount} 元`), 1)
                      ]))
                    }), 128))
                  ])
                ])),
            (packet.list.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(packet.data.message), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]))
  ]))
}
}

})